import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserModel} from '../../api/user-model';
import { showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
import {UsersService} from '../../api/users.service';
import {FilterStorageService} from '../../services/filter-storage.service';

@Component({
  selector: 'app-user-change-password',
  templateUrl: './user-change-password.component.html',
  styleUrls: ['./user-change-password.component.scss']
})
export class UserChangePasswordComponent implements OnInit {
  @Input() user: UserModel;
  @Input() newPassword: string;
  @Input() confirmPassword: string;

  constructor(public activeModal: NgbActiveModal,
              private users: UsersService,
              private filters: FilterStorageService) {}

  ngOnInit() {
  }

  async savePassword() {
    showSpinner(document.getElementById('wrapper')) ;

    this.activeModal.close();

    try {
      await this.users.changePassword(this.filters.getSelectedOrganization().id, this.user.id, {password: this.newPassword}).toPromise();
      alert(`Password has been changed for - ${this.user.firstName} ${this.user.lastName}`);
    } catch (e) {
      alert(e.error.message);
      console.error(e);
    } finally {
      hideSpinner(document.getElementById('wrapper'));
    }
  }
}
